import { groupOffersByRoomType } from '../offers/offerView';
// Aggregates settled per-property outcomes, preserving the property order.
// Properties with no offers are dropped from the market view; failures are
// surfaced separately so the UI can warn without hiding the properties that
// did resolve.
export const aggregateFanOut = (outcomes) => {
    const groups = outcomes.flatMap(outcome => {
        if (!outcome.ok) {
            return [];
        }
        const roomTypes = groupOffersByRoomType(outcome.offers);
        return roomTypes.length > 0 ? [{ property: outcome.property, roomTypes }] : [];
    });
    const failedProperties = outcomes
        .filter(outcome => !outcome.ok)
        .map(outcome => outcome.property);
    return { groups, failedProperties };
};
// Runs the fan-out. `searchOne` is injected so this stays pure of RTK Query and
// unit-testable; a rejected call becomes a failed outcome rather than throwing.
export const fanOutSearch = async (properties, searchOne) => {
    const settled = await Promise.allSettled(properties.map(property => searchOne(property)));
    const outcomes = properties.map((property, index) => {
        const result = settled[index];
        return result.status === 'fulfilled'
            ? { property, ok: true, offers: result.value }
            : { property, ok: false };
    });
    return aggregateFanOut(outcomes);
};
